<template>
    <div id="page">
        <div class="page-content">
            <div class="page-title page-title-small">
                <h2>
                    <!--<button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>-->
                    لیست بروزرسانی ها
                    <!--<button data-menu="HelpMenu" class="position-static mr-1"><i class="fa fa-question-circle helpIco"></i></button>-->
                </h2>
                <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
                <button data-menu="menu-main" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center menu-main-btn"><i class="fa fa-bars"></i></button>
            </div>
            <div class="card header-card shape-rounded" data-card-height="100">
                <div class="card-overlay bg-highlight opacity-95"></div>
                <div class="card-overlay dark-mode-tint"></div>
            </div>

            <div class="card card-style text-center mb-3">
                <div class="content">

                    <div class="list-group list-custom-small list-icon-0">
                        <div class="list-group-div py-2" v-for="item in UpdateList" :key="item.NoticeId">
                            <div class="d-flex align-items-center justify-content-between">
                                <!--<input class="big-checkbox UserSelected" type="checkbox" :value="task.userId" :id="task.userId" :key="task.userId" />-->

                                <a class="border-0" target="_blank" :href="item.url">
                                    <div class="d-flex">
                                        <i class="fa fa-bullhorn text-primary px-3 float-none font-13 opacity-1"></i>
                                        <p class="mb-0 rtl text-right"> {{item.title}}</p>
                                    </div>
                                    <div class="d-flex">
                                        <i class="fa fa-barcode color-pink2-light px-3"></i>
                                        <p class="mb-0"> کد بروزرسانی: <b>{{item.code}}</b></p>
                                    </div>
                                </a>
                                <i class="fa fa-angle-left"></i>
                            </div>
                        </div>
                        <div v-if="Loading" class="d-flex justify-content-center w-100 py-5">
                            <div class="spinner-border color-magenta2-dark" role="status"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Help-Menu title="معرفی موبایل اپلیکیشن تسکینو" keyEn="TaskList"></Help-Menu>
        <!--<div id="smsRechargeHelp" class="menu menu-box-right bg-gray" data-menu-width="100%" data-menu-effect="menu-over">
            <div class="position-relative">
                <button @click="pauseAllVid()" class="close-menu"><i class="fa fa-times text-white font-26"></i></button>
                <div class="card" data-card-height="90">
                    <div class="card-top">
                        <div class="page-title page-title-small">
                            <h2 class="text-center">معرفی موبایل اپلیکیشن تسکینو</h2>
                        </div>
                    </div>
                    <div class="card-overlay bg-highlight opacity-95"></div>
                    <div class="card-overlay dark-mode-tint"></div>

                    <div class="card-bg bg-20"></div>
                </div>
                <div class="card card-style">
                    <div class="content mt-0 pb-2">
                        <div class="list-group list-custom-small list-icon-0 mt-3 border-b">
                            <div data-toggle="collapse" href="#collapse-0" class="collapsed list-group-div" aria-expanded="false">
                                <i class="fa font-14 fa-info-circle color-magenta1-light"></i>
                                <span class="font-14">معرفی موبایل اپلیکیشن تسکینو <span class="badge bg-red2-light mt-0 px-2 py-2 mr-2 position-static">مهم</span></span>
                                <i class="fa fa-angle-down line-height-xl"></i>
                            </div>
                        </div>
                        <div class="collapse border-b pb-3" id="collapse-0" style="">
                            <div class="d-flex justify-content-center">
                                <video class="responsive-video" controls id="video0" preload="none" poster="/assets/images/taskAppHelpVideoPoster.jpg">
                                    <source src="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/Taskino-mobile-app-intro-SmsRecharge.mp4" type="video/mp4">
                                </video>
                            </div>
                            <a href="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/Taskino-mobile-app-intro-SmsRecharge.mp4" download target="_blank" class="btn btn-m btn-full bg-highlight rounded-m font-900 mt-3 mx-3">دانلود</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>-->
    </div>
</template>

<script>
    import VueSimpleAlert from 'vue3-simple-alert';
    import HelpMenu from '../Components/HelpMenu.vue';
    export default {
        components: {
            "Help-Menu": HelpMenu
        },
        data() {
            return {
                page: 1,
                filterId: 0,
                searchKey: "",
                selectedTypeId: 0,
                pageLoaded: false
            };
        },
        computed: {
            UpdateList() {
                return this.$store.getters.GetUpdatesList;
            },
            Loading() {
                return this.$store.getters.GetLoading;
            }
        },

        created() {

            this.$store.dispatch("GetUpdatesListFromServer", {
                pageId: this.page,
                filterId: this.filterId,
                searchKey: this.searchKey
            });
        },
        methods: {

            filterList() {
                this.page = 1;
                this.$store.dispatch("GetUpdatesListFromServer", {
                    pageId: this.page,
                    filterId: this.filterId,
                    searchKey: this.searchKey
                });
            },

            getNextPageUpdateList() {
                this.page++;
                this.$store.dispatch("GetUpdatesListFromServer", {
                    pageId: this.page,
                    filterId: this.filterId,
                    searchKey: this.searchKey
                });
            },


            pauseAllVid() {
                document.querySelectorAll('video').forEach(vid => vid.pause());
            },
        },
        mounted() {
            document.querySelectorAll(".menu-box-right").forEach(a => a.style.display = "block");

            console.log("mounted");
            this.getNextPageUpdateList();

        }
    };
</script>
